module.exports = __webpack_public_path__ + "static/media/me.4f81bfa9.png";